import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface ToastConfig {
  text: string;
  duration: number;
  isDismissable: boolean;
  type?: 'default' | 'error';
  offsetY?: string;
  centerX?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private readonly toastSubject = new Subject<ToastConfig>();
  readonly toast$ = this.toastSubject.asObservable();

  show(text: string, options: Partial<Omit<ToastConfig, 'text'>> = {}): void {
    const { duration = 5000, isDismissable = true, type = 'default', offsetY, centerX } = options;
    this.toastSubject.next({ text, duration, isDismissable, type, offsetY, centerX });
  }

  getToastPosition(element: HTMLElement): { offsetY: string; centerX: string } {
    const rect = element.getBoundingClientRect();
    const offsetPx = Math.max(window.innerHeight - rect.bottom + 24, 24);
    const centerPx = rect.left + rect.width / 2;
    return { offsetY: `${offsetPx}px`, centerX: `${centerPx}px` };
  }

  showAtElement(element: HTMLElement, text: string, options: Partial<Omit<ToastConfig, 'text'>> = {}): void {
    this.show(text, { ...options, ...this.getToastPosition(element) });
  }
}
